import { useAuth } from '@/hooks/useAuth'
import { getGoogleAuthUrl } from '@/stores/authStore'

export function SignedInOnly({ children }: { children: React.ReactNode }) {
  const { isSignedIn, loading } = useAuth()

  if (loading && !isSignedIn) {
    return <p className="pt-10 text-sm text-carbon/60">Loading your account...</p>
  }

  if (!isSignedIn) {
    return (
      <div className="pt-10">
        <p className="mb-4 text-sm text-carbon/70">Sign in to view this part of your account.</p>
        <a
          href={getGoogleAuthUrl()}
          className="inline-flex items-center justify-center gap-2 bg-ink px-6 py-3 text-xs font-medium tracking-[0.12em] text-white transition-all duration-300 hover:bg-wd-orange"
        >
          Continue with Google
        </a>
      </div>
    )
  }

  return <>{children}</>
}
